import { Sparkles, Zap, ArrowUpRight } from "lucide-react";

/**
 * Dashboard-only upsell card promoting the AI Horse-Powered Content Creator.
 * Renders only inside the OnlyBest dashboard surfaces — never used as the
 * public signup CTA (the public movement remains free and values-based).
 *
 * Copy is intentionally compliance-safe: "helps", "supports", "creates
 * opportunities" — no guaranteed followers / leads / income claims.
 */
export default function AIContentCreatorUpsell() {
  return (
    <section
      className="relative overflow-hidden rounded-3xl border border-[#00E5FF]/30 bg-gradient-to-br from-[#0F172A] via-[#0A0F1C] to-[#0F172A] p-5 sm:p-7"
      data-testid="ai-content-creator-upsell"
    >
      {/* Decorative glow — subtle, no AI-slop gradient */}
      <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-[#00E5FF]/20 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-16 -left-16 w-56 h-56 rounded-full bg-[#7C3AED]/15 blur-3xl pointer-events-none" />

      <div className="relative grid md:grid-cols-[auto_1fr_auto] gap-5 items-start md:items-center">
        <div className="inline-flex w-12 h-12 rounded-2xl bg-gradient-to-br from-[#00E5FF] to-[#7C3AED] items-center justify-center flex-shrink-0 shadow-lg shadow-[#00E5FF]/20">
          <Sparkles className="w-6 h-6 text-white" />
        </div>

        <div className="min-w-0">
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#00E5FF]/10 border border-[#00E5FF]/30 text-[10px] uppercase tracking-wider text-[#00E5FF] font-semibold">
              <Zap className="w-3 h-3" /> Upgrade
            </span>
            <span className="text-[10px] uppercase tracking-wider text-[#94A3B8]">
              For OnlyBest creators
            </span>
          </div>
          <h3 className="text-white font-bold text-lg sm:text-xl leading-tight font-['Outfit']">
            Upgrade With a 24/7 AI Content Creator
          </h3>
          <p className="text-[#94A3B8] text-sm leading-relaxed mt-2">
            Take your OnlyBest account to the next level with an AI Horse-Powered
            Content Creator that helps you stay active, visible, and consistent.
            Your AI Content Creator can help create LocalBest posts, content
            ideas, captions, image ideas, video concepts, business
            recommendations, profile updates, engagement suggestions, and
            growth reports. It also helps keep your profile optimized and
            supports your efforts to generate more clicks, leads, followers,
            referrals, and income opportunities.
          </p>
        </div>

        <a
          href="https://aihpower.com/agents"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 w-full md:w-auto px-5 py-3 rounded-full bg-gradient-to-r from-[#00E5FF] to-[#7C3AED] text-white text-sm font-semibold hover:scale-[1.02] active:scale-[0.98] transition shadow-lg shadow-[#00E5FF]/20 flex-shrink-0"
          data-testid="ai-content-creator-upsell-cta"
        >
          Get My AI Content Creator
          <ArrowUpRight className="w-4 h-4" />
        </a>
      </div>
    </section>
  );
}
